export const en = "en";
export const es = "es";
export const ca = "ca";
export const continue_ = "continue";
export const new_ = "new";
export const formStateSession = "formState";
export const email_ = "email";
export const firebase = "firebase";
export const microsoft = "microsoft";

export const texts = {
  en: {
    login: "Log In",
    loginButton: "Log In",
    signin: "Sign In",
    signinMicrosoftButton: "Sign in with Microsoft",
    navbarWelcome: "Hi!",
    navbarChangeProfile: "Change profile",
    navbarLanguageTitle: "Change language to english",
    logout: "Logout",
    newQuiz: "Start quiz",
    continueQuiz: "Continue quiz",
    modalNewQuiz:
      "By restarting this quiz, you are going to delete previous answers. Are you sure to continue?",
    yes: "YES",
    no: "NO",
    selectOptionPlaceholder: "SELECT AN OPTION",
    save: "SAVE",
    cancel: "CANCEL",
    questionsGroupsTitle: "Questions Groups",
    questionGroupsSubtitle: "Indicate the closest answer",
    votingGroupsTitle: "Voting Groups",
    votingGroupsSubtitle: "Indicates the most predominant scenario",
    questionGroupText: "Questions Group",
    votingGroupText: "Voting Group",
    formCompleted: "Form completed successfully",
    downloadResultsButtonText1: "Download IRT Report",
    downloadResultsButtonText2: "Download Draft AI",
    downloadResultsButtonText3: "Download Lite Innovation Lab",
    scenariosTitle: "SCENARIOS",
    scenariosSubtitle:
      "Indicate the most predominant scenario in your organization",
    saveQuestionGroupButton: "Save Questions Group",
    saveVotingGroupButton: "Save Voting Group",
    of: "of",
    responseNA: "N/A",
    start: "start",
    continue: "continue",
    selectQuestionsGroupTitleStart: "Select questions group or voting group to",
    selectQuestionsGroupTitleContinue: "the quiz",
    questionsTitle: "QUESTIONS",
    questionsSubtitle: "Indicate the answer most related to your organization",
    email: "Email",
    emailPlaceholder: "Your Email",
    password: "Password",
    passwordPlaceholder: "Your Password",
    emailError: "Unauthorized user domain",
    microsoftError: "Microsoft Auth Error",
    firebaseError: "Firebase Auth Error",
    HideMenuText: "Hide Menu",
    ShowMenuText: "Show Menu"
  },
  es: {
    login: "Iniciar sesión",
    loginButton: "Iniciar sesión",
    signin: "Registrarse",
    signinMicrosoftButton: "Registrarse con Microsoft",
    navbarWelcome: "¡Hola!",
    navbarChangeProfile: "Cambiar perfil",
    navbarLanguageTitle: "Cambiar idioma a inglés",
    logout: "Cerrar sesión",
    newQuiz: "Iniciar cuestionario",
    continueQuiz: "Continuar cuestionario",
    modalNewQuiz:
      "Al reiniciar este cuestionario, se eliminarán las respuestas anteriores. ¿Está seguro de continuar?",
    yes: "SÍ",
    no: "NO",
    selectOptionPlaceholder: "SELECCIONA UNA OPCIÓN",
    save: "GUARDAR",
    cancel: "CANCELAR",
    questionsGroupsTitle: "Grupos de preguntas",
    questionGroupsSubtitle: "Indica la respuesta más cercana",
    votingGroupsTitle: "Grupos de votación",
    votingGroupsSubtitle: "Indica el escenario más predominante",
    questionGroupText: "Grupo de preguntas",
    votingGroupText: "Grupo de votación",
    formCompleted: "Formulario completado con éxito",
    downloadResultsButtonText1: "Descargar informe IRT",
    downloadResultsButtonText2: "Descargar borrador IA",
    downloadResultsButtonText3: "Descargar Lite Innovation Lab",
    scenariosTitle: "ESCENARIOS",
    scenariosSubtitle:
      "Indica el escenario más predominante en tu organización",
    saveQuestionGroupButton: "Guardar grupo de preguntas",
    saveVotingGroupButton: "Guardar grupo de votación",
    of: "de",
    responseNA: "N/D",
    start: "iniciar",
    continue: "continuar",
    selectQuestionsGroupTitleStart: "Selecciona el grupo de preguntas o grupo de votación para",
    selectQuestionsGroupTitleContinue: "el cuestionario",
    questionsTitle: "PREGUNTAS",
    questionsSubtitle: "Indica la respuesta más relacionada con tu organización",
    email: "Correo electrónico",
    emailPlaceholder: "Tu correo electrónico",
    password: "Contraseña",
    passwordPlaceholder: "Tu contraseña",
    emailError: "Dominio de usuario no autorizado",
    microsoftError: "Error de autenticación de Microsoft",
    firebaseError: "Error de autenticación de Firebase",
    HideMenuText: "Ocultar menú",  
    ShowMenuText: "Mostrar menú"
  }
  ,
  ca: {
    login: "Iniciar sessió",
    loginButton: "Entrar",
    signin: "Iniciar sessió",
    signinMicrosoftButton: "Entrar amb Microsoft",
    navbarWelcome: "Hola!",
    navbarChangeProfile: "Canviar perfil",
    navbarLanguageTitle: "Canviar idioma a català",
    logout: "Tancar sessió",
    newQuiz: "Començar qüestionari",
    continueQuiz: "Continuar qüestionari",
    modalNewQuiz: "En reiniciar aquest qüestionari, s'eliminaran les respostes anteriors. Estàs segur de voler continuar?",
    yes: "SÍ",
    no: "NO",
    selectOptionPlaceholder: "SELECCIONA UNA OPCIÓ",
    save: "DESAR",
    cancel: "CANCEL·LAR",
    questionsGroupsTitle: "Grups de preguntes",
    questionGroupsSubtitle: "Indica la resposta més propera",
    votingGroupsTitle: "Grups de votació",
    votingGroupsSubtitle: "Indica l'escenari més predominant",
    questionGroupText: "Grup de preguntes",
    votingGroupText: "Grup de votació",
    formCompleted: "Formulari completat amb èxit",
    downloadResultsButtonText1: "Descarregar Informe IRT",
    downloadResultsButtonText2: "Descarregar Draft AI",
    downloadResultsButtonText3: "Descarregar Lite Innovation Lab",
    scenariosTitle: "ESCENARIS",
    scenariosSubtitle: "Indica l'escenari més predominant a la teva organització",
    saveQuestionGroupButton: "Desar grup de preguntes",
    saveVotingGroupButton: "Desar grup de votació",
    responseNA: "N/C",
    of: "de",
    start: "iniciar",
    continue: "continuar",
    selectQuestionsGroupTitleStart: "Selecciona un grup de preguntes o un grup de votació per",
    selectQuestionsGroupTitleContinue: "el qüestionari",
    questionsTitle: "PREGUNTES",
    questionsSubtitle: "Indica la resposta més relacionada amb la teva organització",
    email: "Correu electrònic",
    emailPlaceholder: "El teu correu electrònic",
    password: "Contrasenya",
    passwordPlaceholder: "La teva contrasenya",
    emailError: "Dominio d'usuari no autoritzat",
    microsoftError: "Error d'autenticació de Microsoft",
    firebaseError: "Error d'autenticació de Firebase",
    HideMenuText: "Amaga el menú",  
    ShowMenuText: "Mostra el menú"
  },
};
